import { render, staticRenderFns } from "./JImportModal.vue?vue&type=template&id=4eaa4494&scoped=true&"
import script from "./JImportModal.vue?vue&type=script&lang=js&"
export * from "./JImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa4494",
  null
  
)

export default component.exports